import {
  DEFAULT_THEME_CONFIG,
  generatePalette,
} from "@replohq/lattice/blocks/theme-picker/palette";
import { getAgentThemeMode } from "@replohq/lattice/blocks/theme-picker/persistedAgentThemeMode";
import { paletteToCSS } from "@replohq/lattice/blocks/theme-picker/themeCss";
import { useEffectiveThemeMode } from "@replohq/lattice/blocks/theme-picker/useEffectiveThemeMode";

export function useTheme() {
  const mode = getAgentThemeMode() ?? DEFAULT_THEME_CONFIG.mode;
  const effectiveMode = useEffectiveThemeMode(mode);
  const palette = generatePalette(DEFAULT_THEME_CONFIG, effectiveMode);

  return { effectiveMode, palette, cssVars: paletteToCSS(palette) };
}
